import { ref } from 'vue';

import en from './en';
import ru from './ru';

class LocaleStore {
  data = { en, ru };

  langRef = ref('en');

  get lang() {
    return this.langRef.value;
  }

  get = (key, ...args) => {
    const text = this.data[this.lang]?.[key];
    return text != null ? this.decode(text, ...args) : key;
  };

  setLang = (lang) => {
    this.langRef.value = lang;
  };

  decode(template, ...args) {
    return template.replace(/\{([\w_.]+)\}/g, (_, i) => (args[i] != null ? `${args[i]}` : ''));
  }
}

export const localeStore = new LocaleStore();
export const lx = localeStore.get;
